import getKhattabatSelectsStore from "../../../../../../stores/khattabat-stores/selects-store";
import ET3Circle from "../../../../../../core/et3-circle";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";

const SelectMatchConversation = withLiteObserverAndTheme<{ matchID: number }>(
  (props) => {
    const { matchID, theme } = props;
    const { colors } = theme;
    const state = getKhattabatSelectsStore().isMarkedConversation(matchID);

    return (
      <ET3Div
        width={100}
        height={80}
        alignItems={"center"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <ET3Circle
          size={25}
          style={{
            border: `2px solid ${colors.all.dimGray}`,
            backgroundColor: state ? colors.all.green : colors.all.transparent,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer"
          }}
          color={""}
          withShadow={true}
          onClick={() => {
            getKhattabatSelectsStore().toggleMarkConversation({
              userID: matchID
            });
          }}
        ></ET3Circle>
      </ET3Div>
    );
  }
);

export default SelectMatchConversation;
